module.exports = __webpack_public_path__ + "static/media/Saul.90cf66fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/testimonials/Saul.png
// module id = 1431
// module chunks = 0